import { ButtonLarge, ButtonMedium } from "./index";
import * as React from "react";
import { HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const BackButton = ({
  children,
  onClick,
  size,
  ...restProps
}: HTMLAttributes<HTMLButtonElement> & { size?: "large" | "medium" }) => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();
  const Button = size === "large" ? ButtonLarge : ButtonMedium;
  return (
    <Button
      onClick={onClick || (() => navigate(-1))}
      theme="secondary"
      icon={{ position: "left", type: "ArrowLeft" }}
      {...restProps}
    >
      {children || t("goBack")}
    </Button>
  );
};

export default BackButton;
